import { handleActions } from "redux-actions";
import {
    getMetricDataCollectionStatus,
    getMetricDataCollectionStatusSuccess,
    getMetricDataCollectionStatusError,
    clearMetricDataCollectionStatus,
    updateMetricDataCollectionStatus,
} from "modules/Metric/services/MetricDataCollectionStatus/actions";

const initialState = {
    isLoading: false,
    metricData: [],
    count: 0,
};

export const metricDataCollectionStatusReducer = handleActions(
    {
        [clearMetricDataCollectionStatus]: () => ({ ...initialState }),
        [getMetricDataCollectionStatus]: (state) => ({
            ...state,
            metricData: [],
            count: 0,
            isLoading: true
        }),
        [getMetricDataCollectionStatusSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getMetricDataCollectionStatusError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [updateMetricDataCollectionStatus]: (state, { payload }) => ({
            ...state,
            ...payload
        }),
    },
    initialState
);
